import React from 'react';
import { Box, Typography } from '@mui/material';
import ShowCard from './ShowCard';
import useStore from '../store';

export default function WatchListScreen({ onRateShow }) {
  const shows = useStore(s => s.shows);
  const userRatings = useStore(s => s.userRatings);

  const watchlistFromStore = shows.filter(s => {
    const r = userRatings[String(s.id)];
    return r && !r.dismissed && !(r.rating > 0);
  });

  // Also include AI suggestions added to watchlist (rating 0, but not dismissed)
  const aiWatchlist = Object.values(userRatings).filter(r => {
    const showIdStr = String(r.showId);
    const isAiSuggestion = !shows.some(s => String(s.id) === showIdStr);
    const titleMatchInBase = shows.some(s => (s.title || '').toLowerCase().trim() === (r.title || '').toLowerCase().trim());
    
    // Check if this show was added via a Gemini suggestion and should be in the watchlist
    return isAiSuggestion && !titleMatchInBase && !r.dismissed && !(r.rating > 0);
  }).map(r => ({ id: r.showId, ...r }));

  const watchlist = [...watchlistFromStore, ...aiWatchlist];

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mb: 1.5 }}>
        {watchlist.length} show{watchlist.length !== 1 ? 's' : ''} queued
      </Typography>

      {watchlist.length === 0 ? (
        <Typography sx={{ color: 'text.secondary', textAlign: 'center', mt: 8 }}>
          Your queue is empty — add shows from the Suggest tab to get started.
        </Typography>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {watchlist.map(show => (
            <ShowCard key={show.id} show={show} onClick={() => onRateShow(show)} />
          ))}
        </Box>
      )}
    </Box>
  );
}
